<!--
 * @Description: 业务区域
 * @Author: yangsibo
 * @Date: 2022-05-12 08:59:49
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-09 09:58:26
 * @FilePath: \YunYin_admin\src\views\Setting\RoleManagement\index.vue
-->
<template>
  <el-main class="business-area">
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <p class="tip">
        <i class="el-icon-warning"></i
        >根据人员的职能不同生成了对应角色，系统已配置部分角色；系统可自定义角色，为角色配置不同的权限；不同角色下可配置多个账户。
      </p>
      <div class="top-filter">
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item prop="roleName">
            <el-input
              v-model="filterForm.roleName"
              placeholder="角色名称"
              @keyup.enter.native="handleFilterPro"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilterPro">查询</el-button>
            <el-button
              type="primary"
              plain
              @click="handleResetFilter('filterForm')"
              ><i class="el-icon-refresh-right"></i>清空</el-button
            >
          </el-form-item>
        </el-form>
        <div class="btn-panle">
          <el-button @click="handleAddRole" type="primary" icon="el-icon-plus"
            >新增角色
          </el-button>
        </div>
      </div>
      <el-table
        v-loading="loadRoles"
        :data="roles"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{
              (pagination.currentPage - 1) * pagination.pageSize +
              (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="roleName"
          label="角色名称"
          min-width="10%"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="roleRemark"
          label="角色描述"
          min-width="25%"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="deployNum"
          label="已配账户数量"
          min-width="10%"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          min-width="20%"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleEditRoleName(scope.row)"
              >修改名称
            </el-button>
            <el-button type="text" @click="handleMember(scope.row)"
              >成员管理
            </el-button>
            <el-button type="text" @click="handleConfigRoleAuth(scope.row)"
              >配置权限
            </el-button>
            <el-button type="text" @click="handleLookRoleDetail(scope.row)"
              >查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="this.pagination.pageSize"
        :total="pagination.recordTotal"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <!-- 新增角色 -->
    <AddRole
      v-if="dialogAddRoleVisible"
      :dialogAddRoleVisible="dialogAddRoleVisible"
      :systemType="systemType"
      @close="close"
      @getRoleList="getRoleList"
    ></AddRole>
    <!-- 成员管理 -->
    <MemberList
      v-if="dialogMemberVisible"
      :dialogMemberVisible="dialogMemberVisible"
      :systemType="systemType"
      :curRoleDetail="curRoleDetail"
      @close="close"
      @showDialog="showDialog"
      @setData="setData"
    ></MemberList>
    <!-- 移除角色 -->
    <RemoveRole
      v-if="dialogRemoveRoleVisible"
      :dialogRemoveRoleVisible="dialogRemoveRoleVisible"
      :curAccountDetail="curAccountDetail"
      :curRoleDetail="curRoleDetail"
      :systemType="systemType"
      :operation="operation"
      @getRoleList="getRoleList"
      @close="close"
      @setData="setData"
    ></RemoveRole>
    <!-- 修改名称 -->
    <ModifyName
      v-if="dialogNameVisible"
      :dialogNameVisible="dialogNameVisible"
      :ruleForm="ruleForm"
      :systemType="systemType"
      @close="close"
      @getRoleList="getRoleList"
    ></ModifyName>
    <!-- 配置权限 -->
    <ConfigRole
      v-if="dialogConfigRoleAuthVisible"
      :dialogConfigRoleAuthVisible="dialogConfigRoleAuthVisible"
      :systemType="systemType"
      :curRoleDetail="curRoleDetail"
      @close="close"
      @showDialog="showDialog"
    ></ConfigRole>
    <!-- 角色详情  -->
    <DetailRole
      v-if="dialogRoleDetailVisible"
      :systemType="systemType"
      :dialogRoleDetailVisible="dialogRoleDetailVisible"
      :curRoleDetail="curRoleDetail"
      @close="close"
    ></DetailRole>
  </el-main>
</template>

<script>
import AddRole from "./components/AddRole";
import MemberList from "./components/MemberList";
import RemoveRole from "./components/RemoveRole";
import ModifyName from "./components/ModifyName";
import ConfigRole from "./components/ConfigRole";
import DetailRole from "./components/DetailRole";
export default {
  name: "RoleManagement",
  components: {
    AddRole,
    MemberList,
    RemoveRole,
    ModifyName,
    ConfigRole,
    DetailRole,
  },
  data() {
    return {
      filterForm: {
        roleName: "",
      },
      allFilters: {},
      roles: [],
      curRoleDetail: {},
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },

      curAccountDetail: {},
      ruleForm: {
        id: "",
        roleName: "",
        roleRemark: "",
      },
      loadRoles: false,
      dialogAddRoleVisible: false, // 新增角色
      dialogNameVisible: false, // 修改名称
      dialogMemberVisible: false, // 成员管理
      dialogRemoveRoleVisible: false, // 移除角色
      dialogConfigRoleAuthVisible: false, // 配置权限
      dialogRoleDetailVisible: false, // 角色详情
      operation: 1, // 1移除 2删除
      systemType: 2,
    };
  },
  methods: {
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-24 09:27:44
     * @param {*} data 关闭弹窗type
     * @return {*}
     */
    close(data, showType) {
      this[data] = false;
      if (showType) {
        setTimeout(() => {
          let obj = {
            dialogMemberVisible: 1,
            dialogConfigRoleAuthVisible: 2,
          };
          this.operation = obj[data];
          this[showType] = true;
        }, 500);
      }
    },
    /**
     * @description: 打开弹窗
     * @Author: yangsibo
     * @Date: 2022-05-24 09:28:37
     * @param {*} data 显示弹窗type
     * @return {*}
     */
    showDialog(data) {
      this[data] = true;
    },
    /**
     * @description: 给父组件数据赋值
     * @Author: yangsibo
     * @Date: 2022-05-24 09:32:15
     * @param {*} data 赋值数据
     * @return {*}
     */
    setData({ label, value }) {
      this[label] = value;
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2021-12-14 10:40:09
     */
    handleFilterPro() {
      this.pagination.currentPage = 1;
      this.getRoleList();
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-12-14 10:40:34
     * @param {*} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields();
      this.pagination.currentPage = 1;
      this.getRoleList();
    },
    /**
     * @descripttion: 添加角色
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:09:07
     * @param {*} item 当前数据项
     */
    handleAddRole(item) {
      //   this.getMenuTree();
      this.dialogAddRoleVisible = true;
    },
    /**
     * @descripttion: 修改角色名称
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:19:33
     * @param {*} item 当前数据项
     */
    handleEditRoleName(item) {
      this.ruleForm.id = item.id;
      this.ruleForm.roleName = item.roleName;
      this.ruleForm.roleRemark = item.roleRemark;
      this.dialogNameVisible = true;
    },
    /**
     * @descripttion: 成员管理
     * @Author: juanjuanhui
     * @Date: 2022-02-19 16:30:00
     * @param {*} item 当前数据项
     */
    handleMember(item) {
      this.curRoleDetail.id = item.id;
      this.curRoleDetail.roleName = item.roleName;
      let params = {
        roleId: item.id,
      };
      //   this.getAccountList(params);
      this.dialogMemberVisible = true;
    },
    /**
     * @descripttion: 配置角色权限
     * @Author: juanjuanhui
     * @Date: 2022-02-24 17:17:58
     * @param {*} item 当前数据项
     */
    handleConfigRoleAuth(item) {
      this.curRoleDetail = item;
      //   this.getMenuTree({ roleIdList: [item.id] });
      this.dialogConfigRoleAuthVisible = true;
    },
    /**
     * @descripttion: 查看角色详情
     * @Author: juanjuanhui
     * @Date: 2022-02-19 16:42:50
     * @param {*} item 当前数据项
     */
    handleLookRoleDetail(item) {
      this.curRoleDetail = item;
      //   this.getRoleDetail(roleId);
      //   this.getAccountList({ roleId });
      //   this.getSelectOwnMenuTree({ roleIdList: [roleId] });
      this.dialogRoleDetailVisible = true;
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getRoleList();
    },
    /**
     * @description: 获取角色列表
     * @Author: yangsibo
     * @Date: 2022-05-23 17:45:52
     * @return {*}
     */
    async getRoleList() {
      this.loadRoles = true;
      this.roles = [];
      try {
        let { data } = await this.$http.role.getSRoleListNum({
          ...this.filterForm,
          ...this.pagination,
          systemType: this.systemType,
          masterId: 2,
        });
        if (data) {
          let { recordTotal, content: roles } = data;
          this.pagination.recordTotal = recordTotal;
          this.roles = roles;
        }
        this.loadRoles = false;
      } catch (error) {
        this.loadRoles = false;
      }
    },
  },
  created() {
    this.getRoleList();
  },
};
</script>
<style lang="scss" scoped>
.main {
  .tip {
    color: #018388;
    font-size: 16px;
    .el-icon-warning {
      margin-right: 5px;
    }
  }
  .top-filter {
    display: flex;
    justify-content: space-between;
    padding: 20px 0 0;
  }
}
</style>

